import Images from "../../utils/Images";

export default function AboutHero() {
  const fallbackImage =
    "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2126&q=80";

  return (
    <section className="pt-20 relative w-full min-h-[380px] md:min-h-[440px] lg:min-h-[520px] overflow-hidden">
      <img
        src={Images.about_hero || fallbackImage}
        alt="TripSecure Agents About Hero"
        className="object-cover absolute inset-0 w-full h-full"
      />
      {/* Layered, modern overlays */}
      <div className="absolute inset-0 bg-gradient-to-r to-transparent from-black/80 via-black/60" />
      <div className="absolute inset-0 bg-gradient-to-b via-transparent from-black/20 to-black/70" />
      <div className="absolute -left-24 -top-24 w-[420px] h-[420px] rounded-full blur-3xl opacity-30 bg-emerald-500/40" />
      <div className="absolute -right-32 bottom-0 w-[420px] h-[420px] rounded-full blur-3xl opacity-20 bg-emerald-300/30" />

      <div className="relative z-10 px-6 py-16 mx-auto max-w-6xl md:py-24 lg:py-28">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/15 backdrop-blur text-white/80 text-xs">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
          Trusted Insurance Agent Platform
        </div>

        <h1 className="mt-4 text-3xl font-extrabold leading-tight text-white md:text-4xl lg:text-5xl">
          Empowering Insurance Agents-
          <br className="hidden md:block" />
          <span className="inline-block relative text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-emerald-200">
            Build Your Success!
          </span>
        </h1>

        <p className="mt-4 max-w-3xl text-[13px] md:text-sm lg:text-base text-white/85">
          TripSecure is a leading insurance agent platform that empowers professionals to deliver exceptional 
          service and grow their business. We provide cutting-edge tools, comprehensive training, and 
          competitive commission structures. Our platform connects agents with customers seeking reliable 
          insurance solutions, from travel coverage to comprehensive protection plans. Join our network of 
          successful agents and transform your career in the insurance industry.
        </p>

        {/* Quick stats */}
        <div className="grid grid-cols-2 gap-3 mt-8 max-w-xl sm:grid-cols-3">
          {[
            { label: "Active Agents", value: "2,500+" },
            { label: "Insurance Partners", value: "300+" },
            { label: "Commission Paid", value: "GHS 5M+" },
          ].map((s) => (
            <div
              key={s.label}
              className="px-4 py-3 rounded-xl border backdrop-blur-sm border-white/10 bg-white/10 text-white/90"
            >
              <div className="text-lg font-bold text-emerald-300">{s.value}</div>
              <div className="text-[11px] md:text-xs text-white/80">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
